import { parseDateUnit, UNIT_MODIFIER_VALUES } from 'utils/relativeDateTime';

/**
 * getNewRangeValues
 * Get new start and end ranges based on changed value.
 */
export const getNewRangeValues = (value, isToField, defaultUnit) => {
  const { unit, isUnitModifierNow } = parseDateUnit(value);
  const defaultNewValue = unit ? value : `${isToField ? '+1' : '-1'}${defaultUnit}${value}`;
  const newValue = isUnitModifierNow ? value : defaultNewValue;
  const otherValue = isUnitModifierNow
    ? `${isToField ? '-1' : '+1'}${defaultUnit}`
    : UNIT_MODIFIER_VALUES.now;

  return {
    startRange: isToField ? otherValue : newValue,
    endRange: isToField ? newValue : otherValue,
  };
};
